import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/NewVuxComponents/TpDialog.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _c(__unplugin_components_0, {
    staticClass: "refuse-Dialog",
    attrs: {
      "hide-on-blur": "",
      "width": "700",
      "title": i18n.tc("352"),
      "cancel-text": i18n.tc("353"),
      "success-text": i18n.tc("354"),
      "cancelDefaulEvent": false
    },
    on: {
      "on-cancel": function ($event) {
        return _vm.inviteRespond(3);
      },
      "on-success": function ($event) {
        return _vm.inviteRespond(2);
      }
    },
    model: {
      value: _vm.showInviteModal,
      callback: function ($$v) {
        _vm.showInviteModal = $$v;
      },
      expression: "showInviteModal"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "2rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.inviteTip.name) + i18n.tc("355") + _vm._s(_vm.inviteTip.parent_name) + (i18n.tc("356") + " "))])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };